import styled from 'styled-components';
import { Trans } from 'react-i18next';
import { ErrorStatePageError } from 'ui/illustrations/ErrorStatePageError';
import { colors, duration, easing, fontSizes, fontWeights, spacing } from 'ui/theme';

import { useRefetchCampaignsOrBlocks } from './hooks/useRefetchCampaignsOrBlocks';
import { useTranslations } from '../../hooks/useTranslations';

const CtaHeader = styled.div`
  color: ${colors.textPrimary};
  font-size: ${fontSizes.s20};
  font-weight: ${fontWeights.semiBold};
`;

const Cta = styled.div`
  font-size: ${fontSizes.s16};
`;

const EmptyState = styled.div`
  align-items: stretch;
  border-color: ${colors.grey15};
  border-radius: ${spacing.quarter};
  border-style: solid;
  border-width: ${spacing.single};
  color: ${colors.textSecondary};
  display: flex;
  height: 724px;
  width: 352px;
  flex-direction: column;
  justify-content: center;
  padding: ${spacing.plusHalf};
  position: initial;
  row-gap: ${spacing.base};
  transition: all ${duration.short} ${easing.entrance};
`;

const StyledLabel = styled.section`
  align-items: center;
  display: flex;
  flex-direction: column;
  font-size: ${fontSizes.s14};
  font-weight: ${fontWeights.regular};
  row-gap: ${spacing.base};
  text-align: center;
  white-space: pre-wrap;
`;

const StyledDiv = styled.div`
  color: ${colors.textLink};
  cursor: pointer;
  user-select: none;
`;

export const DATA_TEST = {
  error: 'mi-block-campaign-error-state',
  refresh: 'mi-block-campaign-error-state-refresh',
};

export const CampaignAndBlockErrorState = () => {
  const { t } = useTranslations();
  const onRefetch = useRefetchCampaignsOrBlocks();
  const ctaHeader = t('campaignAndBlockErrorState.header');

  return (
    <EmptyState data-test={DATA_TEST.error}>
      <StyledLabel>
        <ErrorStatePageError />
        <CtaHeader>{ctaHeader}</CtaHeader>
        <Cta>
          <Trans
            t={t}
            i18nKey="campaignAndBlockErrorState.message"
            components={{
              click: <StyledDiv onClick={onRefetch} />,
            }}
          >
            <StyledDiv data-test={DATA_TEST.refresh} onClick={onRefetch}>
              try refreshing this list.
            </StyledDiv>
          </Trans>
        </Cta>
      </StyledLabel>
    </EmptyState>
  );
};
